// extracted by mini-css-extract-plugin
module.exports = {"flex":"HistoryOf_flex__3jUXO"};